import type { NavItem } from '@/config/navigation'
import { sidebarSections } from '@/config/navigation'
import { filterNavSections } from '@/composables/useFilteredNavigation'
import { PERMISSIONS } from '@/utils/permissions'

function firstNavPath(items: NavItem[]): string | null {
  for (const item of items) {
    if (item.path) return item.path
    if (item.children?.length) {
      const childPath = firstNavPath(item.children)
      if (childPath) return childPath
    }
  }
  return null
}

/** Default post-login route based on RBAC — avoids sending users to dashboard APIs they cannot call. */
export function resolveDefaultLandingRoute(
  hasPermission: (name: string) => boolean,
): string {
  if (hasPermission(PERMISSIONS.DASHBOARD_VIEW)) {
    return '/'
  }

  const sections = filterNavSections(sidebarSections, hasPermission)
  for (const section of sections) {
    const path = firstNavPath(section.items)
    if (path && path !== '/') return path
  }

  return '/settings'
}
